import React, { createContext, useState } from "react";
import { Tabs } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import BuildPlanComponent from "./BuildPlanComponent";
import CsatFeedbackComponent from "./CsatFeedbackComponent";
import TicketFeedbackComponent from "./TicketFeedbackComponent";
import DeliveryFeedbackComponent from "./DeliveryFeedbackComponent";
import FemaleSurveyComponent from "./FemaleSurveyComponent";
import TreatmentFeedbackComponent from "./TreatmentFeedbackComponent";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import NpsFeedbakComponent from "./NpsFeedbakComponent";

export const FeedbackDate = createContext(null);

function FeedbackTab() {
  const [date, setDate] = useState(new Date());
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  const dateData = {
    startDate: moment(date).startOf("day"),
    endDate: moment(date).endOf("day"),
  };


  const onChange = (key) => {
    navigate(`/feedback?tab=${key}&page=1`);
  };

  const feedbackArray = [
    "Build a Plan",
    "CSAT Feedback",
    "Ticket Feedback",
    "Delivery Feedback",
    "Treatment Feedback",
    "Female Survey",
    "Community NPS"
  ];

  const componentData = {
    "Build a Plan": <BuildPlanComponent />,
    "CSAT Feedback": <CsatFeedbackComponent />,
    "Ticket Feedback": <TicketFeedbackComponent />,
    "Delivery Feedback": <DeliveryFeedbackComponent />,
    "Treatment Feedback": <TreatmentFeedbackComponent />,
    "Female Survey": <FemaleSurveyComponent />,
    "Community NPS": <NpsFeedbakComponent />
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center my-n2">
          <div className="fs-1">FeedBack Data</div>
          <div>
            <DatePicker
              selected={date}
              onChange={(date) => setDate(date)}
              formatWeekDay={(day) => day.slice(0, 3)}
              className="form-control"
              placeholderText="Select Date"
            />
          </div>
        </div>
      }
      component={
        <FeedbackDate.Provider value={dateData}>
          <div className="mt-n3">
            <Tabs
              activeKey={tab}
              onChange={onChange}
              type="card"
            >
              {feedbackArray.map((item, index) => {
                const id = item.split(' ').join('-');
                return (
                  <Tabs.TabPane
                    tab={item}
                    key={id}
                  >
                    {tab === id && componentData[item]}
                  </Tabs.TabPane>
                );
              })}
            </Tabs>
          </div>
        </FeedbackDate.Provider>
      }
    />
  );
}

export default FeedbackTab;